module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/polkolonie/thumbs/7-6c0f1097f9c7b752a051ff9d3681509a.webp";